import styled from 'styled-components';

export const Conteiner = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  grid-gap: 1rem;
  justify-content: center;
  align-items: stretch;

  width: 95%;
  margin: 1rem;
`;

export const ConteinerBotao = styled.div`
  display: flex;
  justify-content: end;

  width: 95%;
`;

export const ContainerCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;

  padding: 20px;

  border-radius: 15px;
  border: solid 1px ${(props) => props.theme[props.cor]};

  p {
    width: 100%;
    margin-bottom: -5px;

    text-align: left;
  }

  span {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    align-self: stretch;

    font-weight: 700;

    overflow: hidden;
  }

  button {
    margin-top: 1rem;
  }
`;
